import { useNavigate } from 'react-router-dom'
import { useAppSelector, useAppDispatch } from '../../store/hooks'
import { logout } from '../../store/authSlice'

export default function UserBar() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const profile = useAppSelector((s) => s.auth.profile)

  const handleLogout = () => {
    dispatch(logout()).then(() => navigate('/login'))
  }

  const initials = profile?.display_name
    ? profile.display_name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2)
    : '?'

  const isAdmin = profile?.app_role === 'admin'
  const isLeader = profile?.app_role === 'leader'

  return (
    <div className="user-bar" data-testid="user-bar">
      <div className="user-bar-left">
        <div
          className="user-avatar"
          onClick={() => navigate('/')}
          data-testid="user-avatar"
        >
          {initials}
        </div>
        <div>
          <div className="user-bar-name" data-testid="user-display-name">
            {profile?.display_name ?? 'User'}
            {isAdmin && <span className="role-badge role-badge-admin">Admin</span>}
            {isLeader && <span className="role-badge role-badge-leader">Leader</span>}
          </div>
          {profile?.role && (
            <div className="user-bar-role" data-testid="user-role">{profile.role}</div>
          )}
        </div>
        {profile?.team_id ? (
          <span className="user-bar-team" data-testid="user-team-id">
            {profile.team_id}
          </span>
        ) : (
          <span className="user-bar-team user-bar-team-none" data-testid="user-no-team">
            No team assigned
          </span>
        )}
      </div>
      <div className="user-bar-right">
        {isAdmin && (
          <a
            className="user-bar-link user-bar-link-admin"
            onClick={() => navigate('/admin')}
            data-testid="admin-link"
          >
            Admin
          </a>
        )}
        {(isLeader || isAdmin) && (
          <a
            className="user-bar-link"
            onClick={() => navigate('/manage')}
            data-testid="manage-link"
          >
            Manage Team
          </a>
        )}
        <button className="btn btn-sm" onClick={() => navigate('/edit-profile')} data-testid="edit-profile-btn">
          Edit Profile
        </button>
        <button className="btn btn-sm" onClick={handleLogout} data-testid="logout-btn">
          Log out
        </button>
      </div>
    </div>
  )
}
